import axios from "axios";
import { BE_HOST } from "../config/config";

let isRefreshing = false;
let failedQueue = [];

const processQueue = (error, token = null) => {
  failedQueue.forEach((prom) => {
    if (error) prom.reject(error);
    else prom.resolve(token);
  });
  failedQueue = [];
};

const instance = axios.create({
  baseURL: BE_HOST,
});

// Request Interceptor
instance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    config.headers.Accept = "application/json";
    // config.headers["Content-Type"] = "application/json";
    if (!config.headers["Content-Type"]) {
  config.headers["Content-Type"] = "application/json";
}
    return config;
  },
  (error) => Promise.reject(error)
);

// Response Interceptor
instance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    if (
      error.response?.status === 401 &&
      !originalRequest._retry
    ) {
      originalRequest._retry = true;
      // localStorage.removeItem("AuthToken");
      // localStorage.removeItem("RoomId");
      // localStorage.removeItem("VisitorID");
      if (isRefreshing) {
        return new Promise((resolve, reject) => {
          failedQueue.push({ resolve, reject });
        }).then((token) => {
          originalRequest.headers.Authorization = `Bearer ${token}`;
          return instance(originalRequest);
        });
      }

      isRefreshing = true;

      try {
        localStorage.removeItem("AuthToken");
        localStorage.removeItem("RoomId");
        localStorage.removeItem("VisitorID");
        localStorage.removeItem("chatRoomId")
        const refreshToken = localStorage.getItem("refreshToken");
        console.log("%c Calling REFRESH TOKEN API...", "color: orange; font-weight: bold;");
        const res = await axios.post(`${BE_HOST}/auth/refresh-token`, {
          refreshToken,
        });

        const newAccessToken = res.data?.accessToken;
        // console.log(newAccessToken,"Newaccesstoken")
        // Save new token
        localStorage.setItem("token", newAccessToken);

        // Update original request with new token
        instance.defaults.headers.Authorization = `Bearer ${newAccessToken}`;
        originalRequest.headers.Authorization = `Bearer ${newAccessToken}`;

        processQueue(null, newAccessToken);

        return instance(originalRequest);
      } catch (refreshError) {
        processQueue(refreshError, null);
        console.error("❌ Refresh token failed. Redirecting to login.");
        localStorage.clear();
        window.location.href = "/login";
        return Promise.reject(refreshError);
      } finally {
        isRefreshing = false;
      }
    }

    return Promise.reject(error);
  }
);

export const axiosInstance = instance;



// import axios from "axios";
// import { TEST_URL } from "../config/config";
// import { useSelector } from "react-redux";

// /**
//  *
//  * parse error response
//  */
// function parseError(messages) {
//   // error
//   if (messages) {
//     if (messages instanceof Array) {
//       return Promise.reject({ messages: messages });
//     } else {
//       return Promise.reject({ messages: [messages] });
//     }
//   } else {
//     return Promise.reject({ messages: ["error"] });
//   }
// }

// /**
//  * axios instance
//  */
// let instance = axios.create({
//   baseURL: TEST_URL,
// });

// // request header
// instance.interceptors.request.use(
//   (config) => {
//     const userAuth = useSelector((state) => state.userAuth.decodedToken);
//     const accessToken = localStorage.getItem("userInfo");
//     let token = userAuth?.idToken;
//     if (token) {
//       config.headers = {
//         Authorization: `Bearer ${token}`,
//         Accept: "application/json",
//         "Content-Type": "application/json",
//       };
//     } else {
//       config.headers = {
//         Accept: "application/json",
//         "Content-Type": "application/json",
//       };
//     }
//     return config;
//   },
//   (error) => {
//     return Promise.reject(error);
//   }
// );

// // response parse
// instance.interceptors.response.use(
//   (response) => {
//     return response;
//   },
//   (error) => {
//     console.warn("Error status", error);
//     if (error.response) {
//       if (error.response.data.message === "Unauthenticated.") {
//         localStorage.removeItem("userInfo");
//         return (window.location = "/");
//       }
//       return parseError(error.response);
//     } else {
//       return Promise.reject(error);
//     }
//   }
// );

// export const axiosInstance = instance;
